module.exports = __webpack_public_path__ + "static/img/core4.23758a39.png";